import { api } from "./api.ts";

type GetBandwidthArgs = {
  fileId: string | number;
};

type TeamMemberBandwidthType = {
  full_name: string;
  task_count: number;
};

type TeamBandwidthType = {
  name: string;
  task_average: number;
};

type BandwidthDataType = {
  team_members: TeamMemberBandwidthType[];
  teams: TeamBandwidthType[];
};

export const clientBandwidthApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBandwidth: build.query<BandwidthDataType, GetBandwidthArgs>({
      query: ({ fileId }) => ({
        url: `api/v1/team_bandwidth`,
        method: "GET",
        params: { file_id: fileId },
      }),
      providesTags: ["TeamBandWidth"],
    }),
  }),
  overrideExisting: true,
});

export const { useGetBandwidthQuery } = clientBandwidthApi;
